
<template>
    <Modal class="myModel"  v-model="isadjust" :styles="{width: '1200px',background:'transparent'}"  :mask-closable="false" footer-hide @on-visible-change="onvisiblechange">
      <div class="first-main-container clearAll">
          <div>
          <div class="wrapBigPic">
              <div class="picList">
                  <img v-for="(item,indx) in allPicArr" :src="item.upadder"  alt="图片加载失败" />         
              </div>
            <button class="turnLeft" @click="turnLeft('isClick')"></button>
            <button class="turnRight" @click="turnRight('isClick')"></button>
          </div>
          <div class="z-div-1 z-ovhid">
            <div class="z-div-1 j-div">
              <img
                v-for="(item,idx) in allPicArr"
                :src="item.upadder"
                alt="图片加载失败"
                :class="flag===idx?'act':''"
                :key="item.upadder+idx"
                @click="changeShowimg(idx)"
              />
            </div>
          </div>
          <Button type="primary" @click="moveDown('isClick')" class="mr-15 z-bdr1 btn-up" ></Button>
          <Button type="primary" @click="moveUp('isClick')" class="mr-15 z-bdr1 btn-down" ></Button>
        </div>
      </div> 
    </Modal> 
</template>

<script>
export default {

  props: {
    ismodelPic: {
      type: Boolean,
      default: false
    },
    allPicArr: {
      type: Array,
      default: []
    },
    clickId: {
      type: Number,
      default: 9999999//默认播放第一张主图
    }
  },
  data () {
    return {
      token: sessionStorage.getItem("name"),
      isadjust: false,
      bigPicIndex: 0,
      flag: 0,
    };
  },
  watch: {
    ismodelPic (TF) {
      this.isadjust = TF;
    },
    allPicArr (val) {
      $('.picList').width(val.length * 1012 + 'px')
    },
    clickId (val) {
      let index = this.allPicArr.map(item => item.upid).indexOf(val)
      this.changeShowimg(index)
      this.moveUp(index)
    }
  },
  methods: {
    onvisiblechange (TF) {
      if (!TF) {
        this.isadjust = TF;
        this.$emit('ismodelPicFn', this.isadjust)
      }
    },
    /**向左播放**/
    turnLeft (param) {
      if (param === 'isClick') {
        if (this.flag <= 0) return false;
        this.flag--;
        this.moveDown()
        $('.picList').animate({ left: `-${this.flag * 1012}px` })
      } else {
        $('.picList').animate({ left: `-${this.flag * 1012}px` })
      }
    },
    /**向右播放**/
    turnRight (param) {
      if (param === 'isClick') {
        let maxlen = this.allPicArr.length - 1
        if (this.flag >= maxlen) return false;
        this.flag++;
        this.moveUp()
        $('.picList').animate({ left: `-${this.flag * 1012}px` })
      } else {
        $('.picList').animate({ left: `-${this.flag * 1012}px` })
      }
    },
    /**右边向下播放图片**/
    moveDown: function (param) {
      if (param === 'isClick') {
        if (this.flag <= 0) return false;
        this.flag--;
        this.turnLeft()
        $('.j-div').animate({ top: `-${this.flag * 112}px` })
      } else {
        $('.j-div').animate({ top: `-${this.flag * 112}px` })
      }
    },
    /**右边向上播放图片**/
    moveUp: function (param) {
      if (param === 'isClick') {
        let maxlen = this.allPicArr.length - 1
        if (this.flag >= maxlen) return false;
        this.flag++;
        this.turnRight()
        $('.j-div').animate({ top: `-${this.flag * 112}px` })
      } else {
        $('.j-div').animate({ top: `-${this.flag * 112}px` })
      }
    },
    changeShowimg (indx) {
      this.flag = indx;
      $('.picList').animate({ left: `-${indx * 1012}px` })
    }
  }
};
</script>

 <style lang="less" scoped>
.first-main-container {
  height: 627px;
  > div {
    float: left;
    .wrapBigPic {
      float: left;
      width: 1012px;
      height: 555px;
      margin-right: 7px;
      position: relative;
      overflow: hidden;
      .picList {
        position: relative;
        // width: 999999px;
        > img {
          width: 1012px;
          height: 555px;
        }
      }
      button {
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        border: 0;
        outline: none;
        width: 25px;
        height: 50px;
        background: transparent;
        // color: #fff;
        // font-weight: 700;
        // font-size: 30px;
      }
      .turnLeft {
        left: 22px;
        background: url("./img/icon_left.svg") no-repeat center;
      }
      .turnRight {
        right: 22px;
        background: url("./img/icon_right.svg") no-repeat center;
      }
    }
    &:nth-of-type(1) {
      margin-left: 10px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      height: 555px;
    }
    &:nth-of-type(2) {
      width: 359px;
      height: 555px;
      padding-top: 40px;
    }
    div.z-div-1 {
      float: left;
      width: 162px;
      height: 555px;
      margin-bottom: 6px;
      position: relative;
      > img {
        float: left;
        width: 162px;
        height: 106px;
        margin-bottom: 6px;
        cursor: pointer;
      }
      > img:hover {
        border: 5px solid #2e70ff;
      }
      > img.act {
        border: 5px solid #2e70ff;
      }
    }

    .ivu-btn-primary {
      position: absolute;
      width: 93px;
      height: 36px;
      border-radius: 0;
      -webkit-border-radius: 0;
      -moz-border-radius: 0;
      &:hover {
        background: #306bea;
      }
    }
    .btn-up {
      top: -37px;
      right: 20px;
    }
    .btn-down {
      bottom: -35px;
      right: 30px;
    }
  }
}
</style>
<style scoped>
.myModel >>> .ivu-modal-close {
  top: -60px !important;
  right: -75px !important;
}
.myModel >>> .ivu-modal-close .ivu-icon-ios-close {
  font-size: 74px;
  color: #fff;
  font-weight: 700;
}
</style>



